import React, { Component } from 'react';
import './MapWidgetUI.scss';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import context from '../context';
import { geometryUtil } from './../util/geometryUtil';
import DrawControl from '../layerManager/DrawControl';
import { SunOutlined, SmileOutlined, FrownOutlined } from '@ant-design/icons';
import '../plugin/leaflet-tilelayer-colorfilter';
const polyStyle = { "size": "2", "color": "#e30909", "fillColor": "rgba(252,219,87,0.4)" };
let standardFilter = [];
let lightFilter = [
    'blur:0px',
    'brightness:95%',
    'contrast:130%',
    'grayscale:20%',
    'hue:290deg',
    'opacity:100%',
    'invert:100%',
    'saturate:300%',
    'sepia:10%',
];
let darkFilter = [
    'blur:0px',
    'brightness:100%',
    'contrast:100%',
    'grayscale:100%',
    'hue:100deg',
    'opacity:100%',
    'invert:100%',
    'saturate:100%',
    'sepia:100%',
];
let oldFilter = [
    'grayscale:100%',
    'invert:100%',
]
let darkMapFilter = [
    'grayscale:100%',
    'invert:100%',
];
let lightMapFilter = [
    'brightness:110%',
    'hue:90deg',
    'saturate:120%',
];
let leftColoFilter = [
    'invert:100%',
    'brightness:115%',
    'hue:186deg',
];
let rightColorFilter = [
    'hue:186deg',
    'brightness:115%',
    'invert:100%',
];
const mapFilter = {
    "Standard": standardFilter,
    "Light": lightFilter,
    "Dark": darkFilter,
}
export default class MapWidgetUI extends Component {
    map = null;
    mapDiv = null;
    tileBaseLayer = null;
    constructor(props) {
        super(props)
        this.state = {
            location: "",
            curTheme: "Standard",
        }
    }
    componentDidMount() {
        this.map = L.map(this.mapDiv, { zoomControl: false }).setView([33.226422, 110.508369], 5);
        this.tileBaseLayer = L.tileLayer.colorFilter("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: '',
            maxZoom: 13,
            minZoom: 3,
            // subdomains: "1234",
            zoom: 3,
            filter: standardFilter,
        }).addTo(this.map);
        this.map.on("moveend", this._onMapMoveend);
        this.map.on("zoomend", this._onMapZoomend);
        this.map.on('click', this._onClick);
        this.map.on('contextmenu', this._onRightClick);

        // 初始化 FeatureGroup 来存储绘制的图形
        var drawnItems = new L.FeatureGroup();
        this.map.addLayer(drawnItems);
        var drawControl = new DrawControl({ drawnItems });
        // 将绘制控件添加到地图上
        this.map.addControl(drawControl);
        let this_ = this
        // 监听绘制完成事件
        this.map.on(L.Draw.Event.CREATED, function (event) {
            var layer = event.layer;
            var layerType = event.layerType;
            drawnItems.addLayer(layer);
            // console.log(layerType);
            // 处理绘制完成后的逻辑
            if (layerType === "polygon") {
                console.log("绘制了一个多边形:", layer.toGeoJSON());
            } else if (layerType === "rectangle") {
                console.log("绘制了一个矩形:", layer.toGeoJSON());
            } else if (layerType === "polyline") {
                console.log("绘制了一个线段:", layer.toGeoJSON());
            } else if (layerType === "marker") {
                console.log("绘制了一个标记:", layer.toGeoJSON());
            } else if (layerType === "circle") {
                console.log("绘制了一个圆:", layer.toGeoJSON());
            }
            this_._onDrawRightClick(layer);
        });

        // 监听编辑和删除事件
        this.map.on(L.Draw.Event.EDITED, function (event) {
            console.log("图形被编辑:", event.layers);
        });

        this.map.on(L.Draw.Event.DELETED, function (event) {
            console.log("图形被删除:", event.layers);
        });

        context.map = this.map;
    }

    componentDidUpdate() {
    }
    componentWillUnmount() {

    }
    updateMapTheme = (val) => {
        this.tileBaseLayer.updateFilter(mapFilter[val]);
    }
    locatedPoint = (coords) => {
        // var myIcon = L.divIcon({className: 'my-div-icon'});
        var myIcon = L.icon({
            iconUrl: './source/images/marker-icon.png',
            iconSize: [20, 30],
            iconAnchor: [10, 30],
            popupAnchor: [0, -30],
        });
        L.marker(coords, { icon: myIcon }).addTo(this.map);
        this.map.setView(coords, 15);
    }
    locatedPolygon = (coords, geomStyle) => {
        let polygon = L.polygon(geometryUtil.coordinates2leaflet(coords), geomStyle || polyStyle).addTo(this.map);
        const center = geometryUtil.getCenterforGeom(coords);
        this.map.setView([center[1], center[0]], 12);
    }
    clearLayer = () => {

    }
    _onMapMoveend = () => {
    }
    _onMapZoomend = (e) => {
    }
    _onClick = (e) => {
        // console.log(e.latlng);
        this.props.onLatLng && this.props.onLatLng(e.latlng);
    }
    _onRightClick = (e) => {
        console.log(e);
    }
    _onDrawRightClick = (layer) => {
        layer.on('contextmenu', (e) => {
            // 阻止右键事件冒泡到地图，防止触发地图本身的右键菜单
            L.DomEvent.stopPropagation(e);
            // 获取该图形的 GeoJSON 数据结构
            var geojsonData = layer.toGeoJSON();
            var wktData = geometryUtil.geoJSONToWkt(geojsonData);
            // 序列化为字符串（美化输出方便阅读）
            var geojsonString = JSON.stringify(geojsonData, null, 2);

            // 创建一个简单的自定义弹出菜单
            var menuContent = `
            <div style="padding: 5px; text-align: center;">
                <p style="margin: 0 0 8px 0; font-size: 12px; color: #666;">检测到围栏图形</p>
                <button class="copy-btn" data-type="geojson" style="padding: 4px 8px; cursor: pointer; background: #007bff; color: white; border: none; border-radius: 3px;">
                    复制 GeoJSON 围栏
                </button>
                <button class="copy-btn" data-type="wkt" style="padding: 4px 8px; cursor: pointer; background: #007bff; color: white; border: none; border-radius: 3px;">
                    复制 WKT 围栏
                </button>
            </div>
            `;
            var popup = L.popup().setLatLng(e.latlng).setContent(menuContent).openOn(this.map);

            // 绑定弹出框内按钮的点击事件
            setTimeout(() => {
                var btns = document.getElementsByClassName('copy-btn');
                for (let btn of btns) {
                    var btnType = btn.dataset.type;
                    var textToCopy = "";
                    if (btnType === 'geojson') {
                        textToCopy = geojsonString;
                    } else if (btnType === 'wkt') {
                        textToCopy = wktData;
                    }
                    btn.onclick = () => {
                        // 调用现代浏览器剪贴板 API
                        navigator.clipboard.writeText(textToCopy).then(() => {
                            this.map.closePopup(popup); // 复制成功后关闭气泡
                        }).catch(function (err) {
                            console.error('复制失败: ', err);
                        });
                    };
                }
            }, 10); // 延时确保 DOM 节点已渲染
        });
    }
    selectTheme = (value) => {
        this.setState({ curTheme: value }, () => {
            this.updateMapTheme(value)
        });
    }
    //<CameraOutlined />
    render() {
        // const className = classNames("item",{"select":true});
        const { curTheme } = this.state;
        return <div className="map_widget" ref={ref => this.mapDiv = ref}>
            <div className="theme">
                <div className={"item" + (curTheme === "Standard" ? " select" : "")} onClick={() => this.selectTheme("Standard")}><SunOutlined />Ordinary</div>
                <div className={"item" + (curTheme === "Light" ? " select" : "")} onClick={() => this.selectTheme("Light")}><SmileOutlined />Light</div>
                <div className={"item" + (curTheme === "Dark" ? " select" : "")} onClick={() => this.selectTheme("Dark")}><FrownOutlined />Dark</div>
            </div>
        </div>
    }
}
